export enum TransactionTypes {
  GET_TRANSACTION_REQUEST = 'GET_TRANSACTION_REQUEST',
  GET_TRANSACTION_REQUEST_SUCCESS = 'GET_TRANSACTION_REQUEST_SUCCESS',
  // GET_TRANSACTION_REQUEST_FAILED = 'GET_TRANSACTION_REQUEST_FAILED',
}

export interface TransactionState {
  transactionsResult: Transaction[]
  loading: boolean
}

export interface Transaction {
  id: string
  amount: string
  date: Date | string
  status: TransactionStatus
  category: TransactionCategory
  symbol: TransactionSymbol
  method: TransactionMethod
  description: string
}

export enum TransactionStatus {
  SUCCESSFUL = 'successful',
  PROCESSING = 'processing',
  CANCELLED = 'cancelled',
  FAILED = 'failed',
}

export enum TransactionChannel {
  CARD = 'card',
  BANK = 'bank',
  SAFE = 'safe',
}

export enum TransactionCategory {
  INVESTMENT = 'investment',
  PLAN = 'plan',
}

export enum TransactionSymbol {
  SAVED = 'S',
  INVESTMENT = 'I',
  WITHDREW = 'W',
}

export enum TransactionMethod {
  CARD = 'card',
  BANK = 'bank',
  SAFE = 'safe',
}
